<template>
  <!-- 对接详情中部左侧内容 -->
  <div class="DockingDetailsCenterLeftContent">
    <el-row class="content">
      <el-col class="give_A_Like" :xs="8" :sm="24">
        <el-row>
          <el-col :xs="24" :sm="24">
            <img src="../../../../public/static/images/handclap.png" alt="" />
          </el-col>
          <el-col :xs="24" :sm="24">
            <span>1</span>
          </el-col>
        </el-row>
      </el-col>
      <el-col class="collect" :xs="8" :sm="24">
        <el-row>
          <el-col :xs="24" :sm="24">
            <img src="../../../../public/static/images/collect3.png" alt="" />
          </el-col>
          <el-col :xs="24" :sm="24">
            <span>4</span>
          </el-col>
        </el-row>
      </el-col>
      <el-col class="share" :xs="8" :sm="24">
        <el-row>
          <el-col :xs="24" :sm="24">
            <img src="../../../../public/static/images/transpond.png" alt="" />
          </el-col>
          <el-col :xs="24" :sm="24">
            <span>分享</span>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
   
    <!-- logoUrl: "../../../../public/static/images/IDG-logo.png", -->
  </div>
</template>

<script>
export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  created: function () {},
  methods: {},
};
</script>

<style scoped>
@media (max-width: 768px) {
  /* .div{
    margin-left: 10px;
    margin-right: 10px;
  } */
  .DockingDetailsCenterLeftContent{
    margin-right: 0px !important;
  }
  .content{
    padding-bottom:0px !important ;
  }
}
.DockingDetailsCenterLeftContent {
  background-color: #1d1d1f;
  border-radius: 8px;
  margin-right: 7px;
}
.content {
  padding: 32px 0;
  color: #fff;
  margin-bottom: 14px;
}
.give_A_Like {
  /* margin: 32px 0; */
  text-align: center;
  opacity: 0.75;
  margin-bottom: 31px;
}
.collect {
  /* margin: 32px 0; */
  text-align: center;
  opacity: 0.75;
  margin-bottom: 31px;
}
.share {
  /* margin: 32px 0; */
  text-align: center;
  opacity: 0.75;
}
</style>